<script setup lang="ts">
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import { ArrowDownIcon } from '@heroicons/vue/20/solid'
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { useStickToBottomContext } from 'vue-stick-to-bottom'
import { cn } from '../utils'

defineOptions({
  inheritAttrs: false,
})

interface Props {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
const { isAtBottom, scrollToBottom } = useStickToBottomContext()
const showScrollButton = computed(() => !isAtBottom.value)

function handleClick() {
  scrollToBottom()
}
</script>

<template>
  <!-- Override ButtonBase's relative positioning so this overlay never resizes the conversation. -->
  <ButtonBase
    v-if="showScrollButton"
    :class="cn('!absolute bottom-4 left-1/2 -translate-x-1/2', props.class)"
    :leading-icon="ArrowDownIcon"
    aria-label="Scroll to bottom"
    color="white"
    shape="circular"
    size="sm"
    type="button"
    v-bind="$attrs"
    @click="handleClick"
  />
</template>
